import { createBrowserClient } from '@supabase/ssr'
import { Database } from "@/utils/types/database";
import { SupabaseClient } from "@supabase/supabase-js";

export const createClient = () : SupabaseClient<Database> =>
  createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
